import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";

const Refund = () => {
  return (
    <>
      <>
      {/* <Header/> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />
  <div className="breadcumb-wrapper" style={{ padding: "50px 0" }}>
    <div className="container">
      <div className="breadcumb-content">
        <h1 className="breadcumb-title">Refund Policy</h1>
        {/* <ul class="breadcumb-menu">
          <li><a href="home-travel.html">Home</a></li>
          <li>About Tourm</li>
      </ul> */}
      </div>
    </div>
  </div>
  {/*======== / Hero Section ========*/}
  {/*==============================
Booking Area  
==============================*/}
  {/*==============================
About Area  
==============================*/}
  <div
    className="about-area position-relative overflow-hidden overflow-hidden space"
    style={{ padding: "30px 0" }}
    id="about-sec"
  >
    <div className="container">
      <div className="row">
        <div className="col-xl-12">
          <div className="termsofuse">
            <h4>CANCELLATION, RETURN &amp; REFUND POLICY</h4>
            <p>
              Your complete booking and shopping satisfaction is our utmost
              priority. We want you happy each and every time you buy from us.
              However indiaboats.in has put in place no-hassle procedures to
              ensure that you can buy from us in confidence and return the item
              if it has manufacturing defect or if an incorrect item is
              delivered.
            </p>
            <p>
              <strong>Bookings. </strong>
              <br />
              Any cancellations will attract certain charges, though we would
              like to not charge any cancellation charges but, you too would
              appreciate that a lot of efforts goes in preparing the boat for a
              pleasurable and memorable trip.
              <br />
              Therefore the charges would be as follows.
            </p>
            <p>
              <strong>Any cancellations done by the customer:</strong>
            </p>
            <ul>
              <li>
                Prior to 72hrs would attract a charge of 25% of the value booked
                <br />
              </li>
              <li>
                Prior to 48hrs would attract a charge of 50% of the value booked
                <br />
              </li>
              <li>
                Prior to 24 hrs. would attract a charge of 75% of the value
                booked
                <br />
              </li>
              <li>
                Anything after 24hrs or no show, there will no refund of any
                kind.
              </li>
            </ul>
            <p>
              Post receipt of the return package, we will proceed to inspect the
              same. Once approved as an eligible return, we will issue either a
              replacement or provide coupons of the appropriate amount. If
              however the return is found not eligible for refund, we will
              courier the same back to you. In either scenario your return issue
              will be closed within 10 days of our receiving of the return
              package from you. We will send you an acknowledgement mail on
              receiving your package and on validating your return. Also we will
              send you a closure mail at the closure of your refund.{" "}
              <b>
                The refunds payment would be done within seven working days from
                the closure for the issue, in the same mode of payment.
              </b>
            </p>
            <p>
              <strong>For cancellations done by the vendor.</strong>
              <br />
              In case, if there is a change in your booking, from the side of
              the vendor, for example due to bad weather, or the boat not
              available due to some technical problems, an alternate boat of a
              similar type will be made available, incase, the customer does not
              want to avail that facility then 100% of the refund will be made
              available.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>For purchases:</strong>
            </p>
            <p>
              Items must be unused, unworn, unwashed and undamaged. Return items
              will only be accepted in their original packaging, including:
              hangers, polyester bags, hang tags on garments. Any items that
              have been damaged, soiled or altered will not be accepted and will
              be sent back to the customer. Any item that you received with tags
              attached must be returned with those tags intact. All packaging,
              including the original manufacturer's containers, must be unmarked
              and not defaced in any manner. Items purchased as part of a set or
              multi- item pack may be returned individually only if it is
              damaged or if an incorrect item is delivered.
              <br />
            </p>
            <p>
              Any return due to the size issue from customers end will not be
              accepted. On our part, we will give you a replacement or will give
              you a complete refund in the form of coupon only (In case of
              non-availability of the product), if the return is due to an error
              on our part (incorrect item sent, damaged/defective product). In
              case of return the shipping charges will be borne by Indiaboats.in
              only if courier is sent by our official courier partner.
              <br />
            </p>
            <p>
              No cash refund will be provided by Indiaboats.in under any
              circumstances. All returns which are not valid will not be
              accepted and will be sent back. In such cases shipping charges
              will not be borne by us. Please note that damaged Goods are
              neither accepted nor replaced under any circumstances. We have
              sole discretion in deciding whether to accept the returns or not
              depending on the merit of the case.
            </p>
            <p>
              Please note Indiaboats.in will not be liable for any damage that
              happens in transit. Returns can be made in the following ways:
            </p>
            <ol>
              <li>
                Courier the product(s) to Indianboats.in
                <br />
              </li>
              <li>
                Intimate us so that we can pick up the product(s) from your
                doorstep (Only if the service is available in your locality).
                You can ask for a reverse pick up by sending a mail at
                customercare@indiaboats.in
              </li>
            </ol>
            <p>
              Should you wish to return all or a part of your order, you need to
              let us know within 24 hours of receiving your parcel
              <br />
              After validating your return request, we will send you an email
              authorizing a return. The mail will have the return shipping
              address along with instructions that would guide you to simplify
              the return process. If you want us to bear shipping charges then
              do send the products only through our official courier partner.
              Please bear in mind that we should receive the return package
              within 7 days of us sending the authorizing email.
              <br />
            </p>
            <p>
              Post receipt of the return package, we will proceed to inspect the
              same. Once approved as an eligible return, we will issue either a
              replacement or provide coupons of the appropriate amount. If
              however the return is found not eligible for refund, we will
              courier the same back to you. In either scenario your return issue
              will be closed within 10 days of our receiving of the return
              package from you. We will send you an acknowledgement mail on
              receiving your package and on validating your return. Also we will
              send you a closure mail at the closure of your refund.
            </p>
            <p>
              As part of usual business practice, if we receive a cancellation
              notice and the order has not been packaged / shipped by us, we
              shall cancel the order and refund the appropriate amount in the
              form of coupons which can then be used for your next purchase. We
              will not be able to cancel orders that have already been processed
              and shipped by us.
            </p>
            <p>
              If the package is couriered through our official partner or picked
              up by Indiaboats.in, the package would be traced till delivery to
              the warehouse, and the customer would be intimated on receiving
              the same. And if sent by you, the package needs to be tracked by
              you and delivery to warehouse ensured. We might ask you to share
              the POD, in case of the package not being traceable, to help
              locate the package. Kindly bear in mind that the next steps
              towards a refund can happen only after the package is received at
              the warehouse.
            </p>
            <p>We do not provide any guarantee on Color/Fabric/ etc.</p>
            <p>
              Never send back an item without consulting with us. It's very
              important that you DO NOT send the item back to us until you have
              verified with us and no credit or replacement shall be given on
              such items.
            </p>
            <p>
              Always report any problems associated with a single order/package
              delivery at the same time. While returning the defective products,
              kindly mark the package as ‘DEFECTIVE RETURN’. Prefer returning
              your items using registered airmail / courier as advised in our
              return authorization mail in order to ensure proper delivery.
            </p>
            <p>&nbsp;</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</>

    </>
  );
};

export default Refund;
